import { Card } from "components/ui/card";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { ReactQueryQueryError } from "data/queries-common";
import {
  InputBatchConfigFormat,
  MappingTableProps,
} from "pages/geoscape-batch/types";

const MappingTable = ({
  isError,
  deleteObjectMutation,
  headers,
  SEARCHTERMS,
  setHeaders,
  batchConfig,
  setBatchConfig,
  updateBatchConfig,
}: MappingTableProps) => {
  const handleProductsChange = (index: number, value: string) => {
    setBatchConfig((prev: any) => ({
      ...prev,
      hubInfo: {
        ...prev.hubInfo,
        sample: {
          ...prev.hubInfo.sample,
          request: [],
          response: [],
        },
      },
    }));

    setHeaders((prevHeaders: InputBatchConfigFormat[]) => {
      const newHeaders = [...prevHeaders];
      newHeaders[index].apiParameter = value;
      return newHeaders;
    });
  };

  const inputApiParameters = batchConfig.input?.format.map(
    (d: any) => d.apiParameter,
  );

  return (
    <>
      {headers.length == 0 && (
        <div className="flex flex-col items-center justify-center">
          <p className="text-sm">No Input</p>
        </div>
      )}

      {headers.length > 0 && (
        <>
          {isError && (
            <p className="text-destructive text-sm">
              Error -{" "}
              {(deleteObjectMutation.error as ReactQueryQueryError).message}
            </p>
          )}
          <div className="flex flex-col items-center w-full">
            {headers.map((header: InputBatchConfigFormat, index: number) => (
              <div
                key={index}
                className="flex gap-4 justify-around w-full mb-4 items-center"
              >
                <p className="flex w-[15%] justify-end text-sm">
                  Column {index + 1}
                </p>
                <Card className="flex-row justify-center gap-4 w-[80%] p-2">
                  <div className="flex flex-col gap-1.5 w-1/2">
                    <Label htmlFor={`name-${index}`}>Column Name</Label>
                    <Input
                      id={`name-${index}`}
                      name="name"
                      type="text"
                      value={header.name}
                      readOnly
                    />
                  </div>
                  <div className="flex flex-col gap-1.5 w-1/2">
                    <Label htmlFor={`products-select-${index}`}>
                      Search Term
                    </Label>
                    <Select
                      value={
                        Object.keys(SEARCHTERMS).includes(header.apiParameter)
                          ? header.apiParameter
                          : "Ignore"
                      }
                      onValueChange={(value) => {
                        handleProductsChange(index, value);
                        updateBatchConfig();
                      }}
                    >
                      <SelectTrigger id={`products-select-${index}`}>
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        {Object.keys(SEARCHTERMS).map((name) => (
                          <SelectItem
                            key={name}
                            value={name}
                            disabled={inputApiParameters.includes(
                              SEARCHTERMS[name],
                            )}
                          >
                            {name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default MappingTable;
